export default __webpack_public_path__ + "static/media/Brochure.d910e260.pdf";